<template>
  <van-popup class="wrap" v-model="showFlag" @click-overlay="click(0)">
    <div>
      <div class="content text-center">
        <h2 v-if="!slotFlag">{{title}}</h2>
        <p v-if="!slotFlag">{{label}}</p>
        <slot></slot>
      </div>
      <div class="button-wrap row">
        <div class="col-6" v-if="!hidenBack">
          <van-button class="gray-bg" block @click="click(0)">返回</van-button>
        </div>
        <div class="col-6" :class="{'center': hidenBack}">
          <van-button type="danger" block @click="click(1)">确定</van-button>
        </div>
      </div>
    </div>
  </van-popup>

</template>
<script>
import { Popup, Button } from 'vant'
import Vue from 'vue'
Vue.use(Popup).use(Button)
export default {
  props: {
    hidenBack: {
      type: Boolean,
      default: false
    },
    showModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    slotFlag () {
      if (this.$slots.default) {
        return true
      } else {
        return false
      }
    },
    showFlag: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    }
  },
  methods: {
    click (e) {
      this.$emit('click', e)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.wrap {
  width: 310px;
  padding: 24px;
  border-radius: 10px;
  overflow: hidden;
}

.content {
  padding-bottom: 15px;
  h2 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  p {
    color: $dark06;
    margin-bottom: 10px;
  }
}

.button-wrap .col-6 {
  &:first-child {
    padding-right: 10px;
  }
  &:last-child {
    padding-left: 10px;
  }
}
  .center{
    margin-left: 25%;
  }
</style>
